import { Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useUserLicenses } from "../../../hooks/users/useUserLicenses";
import { useState } from "react";
import { MelcoModelsUserSubscriptionListItem } from "melco-shared-logic";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { DetailsLicenseDrawer } from "../../licenses/drawer/details/DetailsLicenseDrawer";

type LicensesListPropTypes = {
  userId: string;
  productCode: string;
};

/**
 *  endpoint account/subscriptions 
Type - 1 (activated), 
Type - 2(Transferred), 
Type - 3 (Cancelled)
 */

export const UserLicensesList: React.FC<LicensesListPropTypes> = ({
  userId,
  productCode,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
  } = useUserLicenses(userId, productCode);
  const { t } = useTranslation();
  const [selectedLicenseId, setSelectedLicenseId] = useState<
    string | undefined
  >(undefined);
  const licenseDetailsDrawer = useGenericDrawer();

  // const handleLicenseDetailClick = (licenseId: string) => {
  //   setSelectedLicenseId(licenseId);
  //   licenseDetailsDrawer.openDrawer();
  // };

  const onCloseCallBackFn = () => {
    setSelectedLicenseId(undefined);
  };

  const columns = [
    {
      title: t("users.tabs.licenses.table.columns.name"),
      key: "display_name",
      dataIndex: "display_name",
      // sorter: true,
      width: 30,
      // render: (rowObj: any) => {
      //   return (<TableCellLink onClick={() => {

      //     handleLicenseDetailClick(rowObj.id)
      //   }} to={""}>
      //     {rowObj.display_name}
      //   </TableCellLink>

      //   )
      // }
    },

    {
      title: t("users.tabs.licenses.table.columns.activated_on"),
      key: "activated_on",

      width: 30,
      render: (row: MelcoModelsUserSubscriptionListItem) => {
        return row.activated_on
          ? new Date(row.activated_on).toLocaleString()
          : "";
      },
    },

    {
      title: t("users.tabs.licenses.table.columns.serial_number"),
      key: "serial_number",
      dataIndex: "serial_number",
      //sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.licenses.table.columns.status"),
      key: "type",
      //  dataIndex: "serial_number",
      //     sorter: true,
      width: 30,
      render: (rowObj: any) => (
        <>
          {
            /**
            *  endpoint account/subscriptions 
                Type - 1 (activated), 
                Type - 2(Transferred), 
                Type - 3 (Cancelled)
            */
            t(
              `users.tabs.licenses.account_subscription_status.${rowObj.type}` as any
            )
          }
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <Table
          //  showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={data}
          columns={columns}
          onChange={onTableConfigChange}
          //pagination={pagination}
          pagination={false}
          rowKey="id"
          // rowSelection={rowSelection}
          // onRow={onRow}
          noDataMessage={t("users.tabs.licenses.no_licenses_message")}
          errorComponent={errorComponent}
        //scroll={{ x: 1700 }}
        />
      </div>
      {selectedLicenseId && (
        <DetailsLicenseDrawer
          drawer={licenseDetailsDrawer}
          licenseId={selectedLicenseId}
          onCloseCallBackFn={onCloseCallBackFn}
        />
      )}
    </>
  );
};
